import {
  type AnyElement,
  HashTable,
  HashTableOverflow,
  getNextPrime,
  mergeObjectDeep
} from "@zyzgroup/core-common";
import { VNode, h, hFromEl, mount, patch } from "../vnode";
import { scheduleIdleAsap } from "../animate";

const globalVNodeCache = new HashTable<VNode>({
  objectSignature: (v) => v.name
  // size: getNextPrime(500),
  // overflow: HashTableOverflow.SLIDE
});

// 前提：el已挂载到dom上！
export function getVnode(el: AnyElement, cache = globalVNodeCache): VNode {
  // 性能瓶颈
  let vnode = cache?.find((vnode) => vnode.el == el);
  if (vnode) {
    return vnode;
  }
  vnode = hFromEl(el);
  cache.put(vnode);
  return vnode;
}

// 前提：el已挂载到dom上！
export function updateVnode(
  el: AnyElement,
  update: (vnode: VNode) => void,
  cache = globalVNodeCache
) {
  const vnode = getVnode(el, cache);
  if (!vnode.alternate) {
    vnode.alternate = hFromEl(el);
    mergeObjectDeep(vnode.alternate.props, vnode.props, true);
  }
  update(vnode.alternate);
}

// 更新 vnode to 真实dom
// 前提：el已挂载到dom上！
function patchVnode(cache = globalVNodeCache) {
  cache.update((vnode: VNode) => {
    const alternate = vnode.alternate;
    if (alternate) {
      patch(vnode, alternate);
      // 提高性能：不改变 cache 中 vnode 引用
      vnode.props = alternate.props;
      vnode.alternate = undefined;
      return true;
    } else {
      return true;
    }
  });
}

export function scheduleVnodeImmediately(cache = globalVNodeCache) {
  patchVnode(cache);
}

export function scheduleVnodeAsap(cache = globalVNodeCache) {
  scheduleIdleAsap(() => patchVnode(cache), {
    name: "PATCH_VNODES",
    timeout: 50
  });
}
